import React, { useContext, useEffect, useState } from 'react'
import { Divider } from 'semantic-ui-react'
import { useDispatch, useSelector } from "react-redux";
import { CreateInnerComment, RemoveNoteFromTransaction } from 'src/graphql/conciliacion';
import TransactionInfoBar from './transactionInfoBar';
import DocumentInfoBar from './documentInfoBar';
import { CreateDteInnerComment, RemoveNoteFromDocument } from '../../../../../graphql/documents';
import { importUpdateTransactions } from '../../../../../redux/actions/conciliacion';
import { importUpdateCobranza } from '../../../../../redux/actions/cobranza';
import { UserContext } from 'src/context';
import { importAlertState } from 'src/redux/actions/alert';
import { SendNoteNotificationEmail } from 'src/graphql/emails';
import CommentsTab from 'src/components/comments/CommentsTab';
import DeleteCommentModal from 'src/components/general/DeleteCommentModal';
import './reconcileComments.css';
import 'src/components/general/mentionSuggestions.scss';

const ReconcileComments = ({ data, dataType, findDocumentById, getTransaction, companyId, infoBarEditData }) => {
  const dispatch = useDispatch();
  const userInfo = useContext(UserContext);
  const createInnerComment = CreateInnerComment();
  const createDteInnerComment = CreateDteInnerComment();
  const removeNoteFromDocument = RemoveNoteFromDocument();
  const removeNoteFromTransaction = RemoveNoteFromTransaction();
  const { openSidebar } = useSelector((state) => state.openSidebar);
  const currentUser = useSelector((state) => state.auth);

  const [notes, setNotes] = useState(data?.innerComments || data?.meta?.innerComments || []);
  const [openModal, setOpenModal] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [noteIndex, setNoteIndex] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const userId = currentUser.uid;

  const sendNoteNotificationEmail = SendNoteNotificationEmail();

  useEffect(() => {
    setNotes(data?.innerComments || data?.meta?.innerComments || []);
  }, [data]);

  const handleSubmitComment = async ({ cleanedValue, mentions }) => {
    const documentId = data?.id || data?._id;
    if (!documentId) {
      dispatch(importAlertState({ content: 'No se pudo identificar el documento', state: 'error', duration: 4 }));
      return;
    }

    const input = {
      transactionId: documentId,
      user: { id: userInfo?.id, name: userInfo?.name, email: userInfo?.email },
      date: new Date(),
      comment: cleanedValue,
    };

    try {
      setIsSubmitting(true);

      if (dataType === 'transaction') {
        const result = await createInnerComment.executeMutation({ input });
        if (result?.data?.createInnerComment && !result?.error) {
          setNotes((n) => [...n, input]);
          await getTransaction.reexecuteQuery({ requestPolicy: 'network-only', variables: { id: data?.id } });
          dispatch(importUpdateTransactions(true));
        } else {
          dispatch(importAlertState({ content: 'No se pudo agregar el comentario', state: 'error', duration: 4 }));
          return;
        }
      } else {
        const result = await createDteInnerComment.executeMutation({ input });
        if (result?.data?.createDteInnerComment && !result?.error) {
          setNotes((n) => [...n, input]);
          setTimeout(async () => {
            if (documentId) await findDocumentById.reexecuteQuery({ requestPolicy: 'network-only' });
            dispatch(importUpdateCobranza({ value: true }));
          }, 0);
        } else {
          dispatch(importAlertState({ content: 'No se pudo agregar el comentario', state: 'error', duration: 4 }));
          return;
        }
      }

      if (mentions?.length && dataType !== 'transaction') {
        await sendNoteNotificationEmail.executeMutation({
          noteEmailInput: {
            companyId,
            commenterEmail: input.user.email,
            notificationEmails: mentions,
            documentId: input.transactionId,
            commentNote: input.comment,
            isTransaction: false,
          },
        });
      }
    } catch {
      dispatch(importAlertState({ content: 'No se pudo agregar el comentario', state: 'error', duration: 4 }));
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteRequest = (indexInReversed) => {
    const originalIndex = notes.length - 1 - indexInReversed;
    setSelectedNote(notes[originalIndex]);
    setNoteIndex(originalIndex);
    setOpenModal(true);
  };

  async function removeNote() {
    try {
      if (dataType === 'transaction') {
        await removeNoteFromTransaction.executeMutation({
          companyId,
          transactionId: data?.id,
          noteIndexToRemove: noteIndex,
        });
        await getTransaction.reexecuteQuery({ requestPolicy: 'network-only', variables: { id: data?.id } });
        dispatch(importUpdateTransactions(true));
      } else {
        await removeNoteFromDocument.executeMutation({
          companyId,
          documentId: data?.id,
          noteIndexToRemove: noteIndex,
        });
        findDocumentById.reexecuteQuery({ requestPolicy: 'network-only' });
        dispatch(importUpdateCobranza({ value: true }));
      }
      setOpenModal(false);
    } catch {
      dispatch(importAlertState({ content: 'No se pudo eliminar la nota', state: 'error', duration: 5 }));
    }
  }

  const infoBarSource = infoBarEditData ?? openSidebar?.editData;

  return (
    <div className="comments-tab-container">
      {infoBarSource &&
        (dataType === 'document' ? (
          <DocumentInfoBar editData={infoBarSource} />
        ) : (
          <TransactionInfoBar editData={infoBarSource} />
        ))}
      <Divider className="mb-4" />

      <CommentsTab
        notes={notes}
        companyId={companyId}
        onSubmitComment={handleSubmitComment}
        onDeleteComment={handleDeleteRequest}
        isSubmitting={isSubmitting}
      />

      <DeleteCommentModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onConfirm={removeNote}
        note={selectedNote}
        isLoading={
          removeNoteFromTransaction.fetching || removeNoteFromDocument.fetching
        }
      />
    </div>
  );
};

export default ReconcileComments;
